globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.MainLoader = (function()
{
  function MainLoader($html) {
    if($html.length >= 1)
    {
      this.$html = $html;
      this.init();
    }
  }

  MainLoader.prototype = {
    init: function(){
      this.events();
    },
    events: function() {
      var me = this;

      $(document).on('confirm', function() {
        me.finish();
      });

      $(document).on('confirm:complete', function(e, answer) {
        if(me.isCalled && answer) {
          me.start();
        } else {
          me.finish();
        }
        me.isCalled = false;
      });

      $('.display-loader').on('click', function() {
        me.isCalled = true;
        me.start();
      });
    },
    start: function() {
      this.$html.show();
    },
    loading: function() {
      this.start();
    },
    finish: function(callback) {
      this.$html.hide();
      if(typeof callback === 'function') callback();
    }
  }

  return MainLoader;
})();
